'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'gift';
var width = 512;
var height = 512;
var aliases = [127873];
var unicode = 'f06b';
var svgPathData = 'M308.5 58.7L273.9 128 352 128c26.5 0 48-21.5 48-48 0-26.5-21.6-48-48.2-48-18.3 0-35.1 10.4-43.3 26.7zM160 160L48 160c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-304 0zM48 128l48 0c-10-13.4-16-30-16-48 0-44.2 36-80 80.2-80 30.4 0 58.3 17.2 71.9 44.4L256 92.2 279.9 44.4c13.6-27.2 41.5-44.4 71.9-44.4 44.1 0 80.2 35.8 80.2 80 0 18-6 34.6-16 48l48 0c26.5 0 48 21.5 48 48l0 32c0 20.9-13.4 38.7-32 45.3L480 416c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-162.7C13.4 246.7 0 228.9 0 208l0-32c0-26.5 21.5-48 48-48zm190.1 0L203.5 58.7c-8.2-16.3-25-26.7-43.3-26.7-26.6 0-48.2 21.5-48.2 48 0 26.5 21.5 48 48 48l78.1 0zM64 416c0 17.7 14.3 32 32 32l144 0 0-192-176 0 0 160zm208 32l144 0c17.7 0 32-14.3 32-32l0-160-176 0 0 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGift = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;